<template>
  <v-simple-table>
    <template v-slot:default>
      <tbody>
        <tr>
          <td>Принято наличных</td>
          <td>
            {{ cashAmount.acceptedCash }} <span class="currency-rub"></span>
          </td>
        </tr>
        <tr>
          <td>Сдано в кассу</td>
          <td>
            {{ cashAmount.depositedCheckout }}
            <span class="currency-rub"></span>
          </td>
        </tr>
        <tr>
          <td>Остаток</td>
          <td>{{ cashAmount.deviation }} <span class="currency-rub"></span></td>
        </tr>
        <tr>
          <td>Инкассация в банк</td>
          <td>
            {{ cashAmount.bankCollection }} <span class="currency-rub"></span>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: "CheckCashAmount",
  props: ["cashAmount"],
};
</script>
